import { createPageStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var useShowBalanceStore = createPageStore({
    initialValues: INITIAL_STATE,
});
